exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-5ae6c8a7] .ant-input-number {\n  width: 100% !important;\n}\n", ""]);

// exports
